/* Keyboard focus ring helper — pairs with assets/custom.css (.lf-keyboard-focus).
   Puts the ring on the interactive host (not an inner icon/svg/span), and works
   even when :focus-visible does not match (e.g. embedded previews). */
(function () {
  var FOCUS_CLASS = 'lf-keyboard-focus';
  var CONTAIN_CLASS = 'lf-focus-containing-block';
  var HOST_SELECTOR = [
    'a[href]',
    'button',
    'input',
    'select',
    'textarea',
    'summary',
    'area[href]',
    '[tabindex]:not([tabindex="-1"])',
    '[role="button"]',
    '[role="link"]',
    '[role="menuitem"]',
    '[role="tab"]',
    '[role="option"]',
    '[role="switch"]',
    '[role="checkbox"]',
    '[role="radio"]',
    '[contenteditable="true"]'
  ].join(',');
  var hadKeyboardEvent = false;
  var focusedEl = null;

  function clearFocusClass() {
    if (focusedEl) {
      focusedEl.classList.remove(FOCUS_CLASS);
      focusedEl.classList.remove(CONTAIN_CLASS);
      focusedEl = null;
    }
  }

  function focusHost(node) {
    if (!(node instanceof Element)) {
      if (node && node.parentElement) return focusHost(node.parentElement);
      return null;
    }
    var host = node.closest(HOST_SELECTOR);
    return host || node;
  }

  window.addEventListener('keydown', function (event) {
    if (event.metaKey || event.ctrlKey || event.altKey) return;
    hadKeyboardEvent = true;
    if (event.key === 'Tab') {
      document.body.classList.add('tab-used');
    }
  }, true);

  window.addEventListener('mousedown', function () {
    hadKeyboardEvent = false;
    clearFocusClass();
  }, true);

  window.addEventListener('pointerdown', function (event) {
    if (event.pointerType === 'mouse' || event.pointerType === 'touch' || event.pointerType === 'pen') {
      hadKeyboardEvent = false;
      clearFocusClass();
    }
  }, true);

  window.addEventListener('focusin', function (event) {
    clearFocusClass();
    if (!hadKeyboardEvent && !document.body.classList.contains('tab-used')) return;
    if (!hadKeyboardEvent) return;
    var host = focusHost(event.target);
    if (!host) return;
    host.classList.add(FOCUS_CLASS);
    if (window.getComputedStyle(host).position === 'static') {
      host.classList.add(CONTAIN_CLASS);
    }
    focusedEl = host;
  }, true);

  window.addEventListener('focusout', function (event) {
    var host = focusHost(event.target);
    if (host) {
      host.classList.remove(FOCUS_CLASS);
      host.classList.remove(CONTAIN_CLASS);
    }
    if (focusedEl && (focusedEl === event.target || focusedEl === host)) {
      focusedEl = null;
    }
  }, true);
})();

/* "Close" button is not focusable */
(function () {
  var OPEN_CLASS = 'kiwi-sizing-modal-visible';
  var MODAL_SEL = '.kiwi-sizing-modal';
  var CLOSE_SEL = '.ks-modal-close, [data-modal-close]';
  var TRIGGER_SEL = [
    '.ks-chart-modal-link',
    '.sizing-chart-modal-link',
    '.ks-chart-modal-button',
    '.sizing-chart-modal-button',
    '.ks-chart-container.ks-container-with-modal',
    '.sizing-chart-container.ks-container-with-modal'
  ].join(', ');
  var FOCUSABLE = [
    'a[href]',
    'area[href]',
    'button:not([disabled])',
    'input:not([type="hidden"]):not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'iframe',
    '[contenteditable="true"]',
    '[tabindex]:not([tabindex^="-"])'
  ].join(',');

  var lastTrigger = null;
  var activeModal = null;
  var focusTimer = null;

  function isOpen() {
    return document.documentElement.classList.contains(OPEN_CLASS);
  }

  function modalEl() {
    return document.querySelector(MODAL_SEL);
  }

  function isVisible(el) {
    if (!(el instanceof Element)) return false;
    if (el.hasAttribute('disabled') || el.hasAttribute('hidden')) return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;
    var style = window.getComputedStyle(el);
    if (style.visibility === 'hidden' || style.display === 'none') return false;
    return el.getClientRects().length > 0;
  }

  function focusables(container) {
    if (!container) return [];
    return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), isVisible);
  }

  function closeButton(modal) {
    if (!modal) return null;
    var nodes = modal.querySelectorAll(CLOSE_SEL);
    for (var i = 0; i < nodes.length; i++) {
      if (isVisible(nodes[i])) return nodes[i];
    }
    return nodes[0] || null;
  }

  function enhanceClose(close) {
    if (!(close instanceof Element)) return;
    if (!close.getAttribute('role')) close.setAttribute('role', 'button');
    if (close.tabIndex < 0) close.setAttribute('tabindex', '0');
    if (!close.getAttribute('aria-label')) close.setAttribute('aria-label', 'Close');
    if (close.dataset.lfKsModalClose) return;
    close.dataset.lfKsModalClose = 'true';
    close.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
      event.preventDefault();
      close.click();
    });
  }

  function rememberOutsideFocus(modal) {
    var active = document.activeElement;
    if (!(active instanceof HTMLElement)) return;
    if (active === document.body || active === document.documentElement) return;
    if (modal && modal.contains(active)) return;
    lastTrigger = active;
  }

  function focusClose(modal) {
    if (!modal) return;
    var close = closeButton(modal);
    enhanceClose(close);
    if (close) {
      close.focus();
      return;
    }
    var first = focusables(modal)[0];
    if (first) first.focus();
  }

  function activate(modal) {
    if (!modal) return;
    if (activeModal !== modal) {
      rememberOutsideFocus(modal);
      activeModal = modal;
    }
    enhanceClose(closeButton(modal));
    clearTimeout(focusTimer);
    focusClose(modal);
    // Kiwi focuses .kiwi-sizing-modal-inner 100ms after open.
    focusTimer = setTimeout(function () {
      if (activeModal === modal && isOpen()) focusClose(modal);
    }, 120);
  }

  function deactivate() {
    clearTimeout(focusTimer);
    var trigger = lastTrigger;
    var modal = activeModal;
    activeModal = null;
    lastTrigger = null;
    if (!trigger || !document.contains(trigger) || typeof trigger.focus !== 'function') return;
    if (modal && modal.contains(trigger) && isVisible(modal)) return;
    trigger.focus();
  }

  function sync() {
    var modal = modalEl();
    if (isOpen() && modal) activate(modal);
    else if (activeModal) deactivate();
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      var trigger = target.closest(TRIGGER_SEL);
      if (trigger) lastTrigger = trigger;
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Tab' || !activeModal || !isOpen()) return;

      var items = focusables(activeModal);
      if (!items.length) {
        event.preventDefault();
        focusClose(activeModal);
        return;
      }

      var first = items[0];
      var last = items[items.length - 1];
      var current = event.target instanceof Element ? event.target : null;
      var inside = current && activeModal.contains(current);

      if (event.shiftKey) {
        if (!inside || current === first) {
          event.preventDefault();
          last.focus();
        }
        return;
      }
      if (!inside || current === last) {
        event.preventDefault();
        first.focus();
      }
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (event) {
      if (!activeModal || !isOpen()) return;
      var target = event.target;
      if (!(target instanceof Element)) return;
      if (!activeModal.contains(target)) {
        // Kiwi focuses the stored trigger in onBeforeClose before it
        // removes .kiwi-sizing-modal-visible. Do not steal that back.
        if (target === lastTrigger) return;
        focusClose(activeModal);
        return;
      }
      if (target.matches('.kiwi-sizing-modal-inner') && closeButton(activeModal)) {
        focusClose(activeModal);
      }
    },
    true
  );

  window.lfA11y.once(sync, { priority: 'critical' });
})();

/* Desktop header menus: Escape closes the open submenu and returns
   focus to the parent item. Left/Right switch top-level menus. Down/Up
   move through submenu items. */
(function () {
  var SHOW_CLASS = 'navigation__item--show-children';
  var CLOSED_CLASS = 'navigation__item--kb-closed';
  var DESKTOP_MQ = '(min-width: 768px)';

  function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function mainNav() {
    return document.getElementById('main-nav');
  }

  function proxyNav() {
    return document.getElementById('proxy-nav');
  }

  function usesProxyNav() {
    var pageHeader = document.querySelector('.pageheader--layout-inline-permitted');
    return !!(pageHeader && proxyNav());
  }

  function childByClass(parent, className) {
    if (!parent) return null;
    for (var i = 0; i < parent.children.length; i++) {
      if (parent.children[i].classList.contains(className)) {
        return parent.children[i];
      }
    }
    return null;
  }

  function tier1Items(nav) {
    if (!nav) return [];
    var list = nav.querySelector('.navigation__tier-1');
    if (!list) return [];
    return Array.prototype.slice.call(list.children).filter(function (el) {
      return el.classList.contains('navigation__item');
    });
  }

  function topLink(item) {
    return childByClass(item, 'navigation__link');
  }

  function dropdownContainer(item) {
    return item && item.querySelector('.navigation__tier-2-container');
  }

  function submenuLinks(item) {
    var container = dropdownContainer(item);
    if (!container) return [];
    return Array.prototype.slice.call(
      container.querySelectorAll('a[href]:not(.navigation__children-toggle)')
    );
  }

  function setExpanded(item, expanded) {
    var link = topLink(item);
    if (link && link.hasAttribute('aria-expanded')) {
      link.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
    var proxy = proxyNav();
    var nav = mainNav();
    if (!proxy || !nav) return;
    var index = tier1Items(nav).indexOf(item);
    var proxyItem = tier1Items(proxy)[index];
    var proxyLink = topLink(proxyItem);
    if (proxyLink && proxyLink.hasAttribute('aria-expanded')) {
      proxyLink.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }

  function clearNavTimeouts(item) {
    if (!item) return;
    clearTimeout(item.dataset.navCloseTimeoutId);
    clearTimeout(item.dataset.navOpenTimeoutId);
  }

  function closeItem(item, keepClosedWhileFocused) {
    if (!item) return;
    clearNavTimeouts(item);
    item.classList.remove(SHOW_CLASS);
    if (keepClosedWhileFocused) {
      item.classList.add(CLOSED_CLASS);
    } else {
      item.classList.remove(CLOSED_CLASS);
    }
    setExpanded(item, false);
    var header = item.closest('.section-header');
    if (header && !header.querySelector('.' + SHOW_CLASS)) {
      header.classList.remove('section-header--nav-open');
    }
  }

  function openItem(item) {
    if (!item || !item.classList.contains('navigation__item--with-children')) return;
    var nav = mainNav();
    tier1Items(nav).forEach(function (other) {
      if (other === item) return;
      closeItem(other, false);
    });
    clearNavTimeouts(item);
    item.classList.remove(CLOSED_CLASS);
    item.classList.add(SHOW_CLASS);
    setExpanded(item, true);
    var header = item.closest('.section-header');
    if (header) header.classList.add('section-header--nav-open');
  }

  function isMenuOpen(item) {
    if (!item) return false;
    if (item.classList.contains(CLOSED_CLASS)) return false;
    if (item.classList.contains(SHOW_CLASS)) return true;
    return document.body.classList.contains('tab-used') && item.contains(document.activeElement);
  }

  function visibleTopLink(mainItem) {
    var nav = mainNav();
    var index = tier1Items(nav).indexOf(mainItem);
    if (usesProxyNav()) {
      var proxyItem = tier1Items(proxyNav())[index];
      var proxyLink = topLink(proxyItem);
      if (proxyLink) return proxyLink;
    }
    return topLink(mainItem);
  }

  function contextFrom(el) {
    if (!(el instanceof Element)) return null;
    if (el.closest('.mobile-navigation-drawer')) return null;

    var nav = mainNav();
    if (!nav) return null;

    var mainItem = el.closest('#main-nav .navigation__tier-1 > .navigation__item');
    if (mainItem) {
      var parentLink = topLink(mainItem);
      var parentToggle = childByClass(mainItem, 'navigation__children-toggle');
      return {
        mainItem: mainItem,
        inSubmenu: el !== parentLink && el !== parentToggle
      };
    }

    var proxyItem = el.closest('#proxy-nav .navigation__tier-1 > .navigation__item');
    if (proxyItem) {
      var proxyIndex = tier1Items(proxyNav()).indexOf(proxyItem);
      var mapped = tier1Items(nav)[proxyIndex];
      if (!mapped) return null;
      return {
        mainItem: mapped,
        inSubmenu: false
      };
    }

    return null;
  }

  function focusFirstSubmenu(item) {
    var links = submenuLinks(item);
    if (links[0]) links[0].focus();
  }

  function moveInSubmenu(item, current, dir) {
    var links = submenuLinks(item);
    if (!links.length) return;
    var index = links.indexOf(current);
    if (index === -1) {
      links[0].focus();
      return;
    }
    var nextIndex = index + dir;
    if (nextIndex < 0) {
      var parent = visibleTopLink(item);
      if (parent) parent.focus();
      return;
    }
    if (nextIndex >= links.length) nextIndex = 0;
    links[nextIndex].focus();
  }

  function changeMenu(item, dir) {
    var items = tier1Items(mainNav());
    var index = items.indexOf(item);
    if (index === -1 || !items.length) return;
    var next = items[(index + dir + items.length) % items.length];
    var nextHasMenu = next.classList.contains('navigation__item--with-children');
    closeItem(item, false);
    if (nextHasMenu) {
      openItem(next);
    }
    var nextTop = visibleTopLink(next);
    if (nextTop) nextTop.focus();
  }

  document.addEventListener(
    'keydown',
    function (event) {
      if (!isDesktop()) return;
      if (event.metaKey || event.ctrlKey || event.altKey) return;

      var key = event.key;
      if (key !== 'Escape' && key !== 'Esc' && key !== 'ArrowDown' && key !== 'ArrowUp' && key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Enter') {
        return;
      }

      var ctx = contextFrom(event.target);
      if (!ctx) return;

      var item = ctx.mainItem;
      var rtl = document.documentElement.getAttribute('dir') === 'rtl';
      var hasMenu = item.classList.contains('navigation__item--with-children');

      if (key === 'Enter') {
        /* After Escape, kb-closed keeps the submenu hidden while the link
           stays focused. Enter is an explicit re-open: clear it (capture
           phase, before the theme's toggle runs) or the theme re-adds
           show-children but the CSS keeps the menu invisible. */
        if (hasMenu) item.classList.remove(CLOSED_CLASS);
        return;
      }

      if (key === 'Escape' || key === 'Esc') {
        if (!hasMenu || (!isMenuOpen(item) && !ctx.inSubmenu)) return;
        event.preventDefault();
        closeItem(item, true);
        var parent = visibleTopLink(item);
        if (parent) parent.focus();
        return;
      }

      if (key === 'ArrowDown') {
        if (!hasMenu) return;
        event.preventDefault();
        openItem(item);
        if (ctx.inSubmenu) {
          moveInSubmenu(item, event.target, 1);
        } else {
          focusFirstSubmenu(item);
        }
        return;
      }

      if (key === 'ArrowUp') {
        if (!hasMenu || !ctx.inSubmenu) return;
        event.preventDefault();
        moveInSubmenu(item, event.target, -1);
        return;
      }

      var dir = 0;
      if (key === 'ArrowLeft') dir = rtl ? 1 : -1;
      if (key === 'ArrowRight') dir = rtl ? -1 : 1;
      if (!dir) return;

      event.preventDefault();
      changeMenu(item, dir);
    },
    true
  );

  document.addEventListener(
    'focusout',
    function (event) {
      var item = event.target && event.target.closest
        ? event.target.closest('#main-nav .navigation__tier-1 > .navigation__item')
        : null;
      if (!item || !item.classList.contains(CLOSED_CLASS)) return;
      var next = event.relatedTarget;
      if (next instanceof Node && item.contains(next)) return;
      item.classList.remove(CLOSED_CLASS);
    },
    true
  );
})();

/* After search results appear, focus is trapped between the Search field and Close */
(function () {
  var overlay = null;
  var listening = false;

  function searchOverlay() {
    return document.querySelector('main-search.main-search');
  }

  function isOpen() {
    return document.body.classList.contains('show-search');
  }

  function unlockResults(container) {
    if (!container) return;
    container.querySelectorAll(
      '.main-search__results a[href], .main-search__results [role="option"] a[href], .main-search__suggestions a[href], .search-suggestions a[href], .main-search__results-all-link'
    ).forEach(function (link) {
      if (link.getAttribute('tabindex') === '-1') link.removeAttribute('tabindex');
      if (link.getAttribute('role') === 'presentation') link.removeAttribute('role');
    });
    container.querySelectorAll('.main-search__results [role="option"]').forEach(function (opt) {
      if (opt.matches('a, button')) return;
      var link = opt.querySelector('a[href]');
      if (link && link.getAttribute('tabindex') === '-1') link.removeAttribute('tabindex');
    });
  }

  function isTabbable(el) {
    if (!(el instanceof Element)) return false;
    if (el.hasAttribute('disabled') || el.hidden) return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;
    if (el.closest('[aria-hidden="true"]:not(main-search)')) return false;
    var tab = el.getAttribute('tabindex');
    if (tab !== null && parseInt(tab, 10) < 0) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return el.getClientRects().length > 0;
  }

  function tabbables(container) {
    if (!container) return [];
    unlockResults(container);
    var selector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([type="hidden"]):not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex^="-"])'
    ].join(',');
    return Array.prototype.filter.call(container.querySelectorAll(selector), isTabbable);
  }

  function onKeydown(event) {
    if (!isOpen() || event.key !== 'Tab') return;
    overlay = searchOverlay();
    if (!overlay) return;
    var list = tabbables(overlay);
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    var active = document.activeElement;
    if (!overlay.contains(active)) {
      event.preventDefault();
      first.focus();
      return;
    }
    if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* Always listening: onKeydown no-ops while the overlay is closed, and this
     way the trap works even when the overlay opens after the once-scan. */
  if (!listening) {
    document.addEventListener('keydown', onKeydown, true);
    listening = true;
  }

  window.lfA11y.once(function () {
    if (!isOpen()) return;
    overlay = searchOverlay();
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    unlockResults(overlay);
  }, { priority: 'critical' });
})();

/* Focus is obscured by the search overlay */
(function () {
  function overlayEl() {
    return document.querySelector('main-search.main-search');
  }

  function markInert(on) {
    if (!on) {
      if (!document.body.classList.contains('reveal-mobile-nav')) {
        window.lfInert.release();
      }
      return;
    }
    if (!document.body.classList.contains('reveal-mobile-nav')) {
      window.lfInert.release();
    }
    var overlay = overlayEl();
    if (overlay) window.lfInert.hideSiblings(overlay);
  }

  function revealFocused(event) {
    if (!document.body.classList.contains('show-search')) return;
    var target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.closest('main-search')) return;
    if (typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  document.addEventListener('focusin', revealFocused, true);

  var lastOpen = null;
  function sync() {
    var open = document.body.classList.contains('show-search');
    if (open === lastOpen) return;
    lastOpen = open;
    markInert(open);
  }

  function onToggle(event) {
    var t = event.target.closest && event.target.closest(
      '.show-search-link, .main-search__close, .main-search__button'
    );
    if (!t && event.type === 'keydown' && event.key !== 'Escape') return;
    if (event.type === 'keydown' && event.key !== 'Escape' && event.key !== 'Tab') return;
    if (event.type === 'keydown' && event.key === 'Tab') {
      setTimeout(sync, 0);
      return;
    }
    setTimeout(sync, 0);
  }

  document.addEventListener('click', onToggle, true);
  document.addEventListener('keydown', onToggle, true);
  if (document.body) {
    new MutationObserver(sync).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  window.lfA11y.once(sync, { priority: 'critical' });
})();

/* Focus does not move into (or stay in) the Reward overlay */
(function () {
  var wasOpen = false;

  function visibleBox(el) {
    if (!(el instanceof Element)) return false;
    if (el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true' || el.inert) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 2 && rect.height > 2;
  }

  function firstVisible(nodes) {
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el && !el.matches('[role="dialog"]')) el = el.closest('[role="dialog"]') || el;
      if (visibleBox(el)) return el;
    }
    return null;
  }

  function rewardDialog() {
    return firstVisible(document.querySelectorAll(
      '[aria-label="Reward"][role="dialog"], [data-testid="klaviyo-form-RwQTpJ"], #headlessui-portal-root [role="dialog"], .lp99_modal[role="dialog"]'
    ));
  }

  function pageOverlayOpen() {
    return document.body.classList.contains('show-search')
      || document.body.classList.contains('reveal-mobile-nav');
  }

  function clearInert() {
    if (window.lfInert && window.lfInert.release) window.lfInert.release();
    if (pageOverlayOpen()) return;
    if (window.lfInert && window.lfInert.releaseChrome) window.lfInert.releaseChrome();
  }

  function applyInert(dialog) {
    if (window.lfInert && window.lfInert.release) window.lfInert.release();
    if (window.lfInert && window.lfInert.hideSiblings) window.lfInert.hideSiblings(dialog);
  }

  function watch(el) {
    if (!el || el.dataset.lfRewardWatch) return;
    el.dataset.lfRewardWatch = 'true';
    new MutationObserver(function () { trap(); }).observe(el, {
      attributes: true,
      attributeFilter: ['style', 'hidden', 'class', 'aria-hidden']
    });
  }

  function watchKnown() {
    document.querySelectorAll(
      '[aria-label="Reward"][role="dialog"], [data-testid^="klaviyo-form"], #headlessui-portal-root, .lp99_modal, .klaviyo-form'
    ).forEach(watch);
  }

  function trap() {
    watchKnown();
    var dialog = rewardDialog();
    if (!dialog) {
      /* Always restore. Slow laptops often hide the overlay after the
         first click timeouts, so a wasOpen-only release leaves tabindex. */
      clearInert();
      wasOpen = false;
      return;
    }
    watch(dialog);
    if (!wasOpen) {
      applyInert(dialog);
      if (!dialog.contains(document.activeElement)) {
        if (dialog.tabIndex < 0) dialog.setAttribute('tabindex', '-1');
        dialog.focus();
      }
    }
    wasOpen = true;
  }

  function settle() {
    var n = 0;
    (function tick() {
      trap();
      n += 1;
      if (n < 16 && (wasOpen || rewardDialog())) setTimeout(tick, 200);
    })();
  }

  function focusables(dialog) {
    return Array.prototype.filter.call(
      dialog.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      settle();
      return;
    }
    if (event.key !== 'Tab') return;
    /* Lazy engage: Klaviyo mounts the dialog long after the once-scan, so the
       first Tab while it is open must also apply inert + initial focus. */
    trap();
    var dialog = rewardDialog();
    if (!dialog) return;
    var list = focusables(dialog);
    if (!list.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }
    var first = list[0];
    var last = list[list.length - 1];
    var active = document.activeElement;
    if (event.shiftKey && (active === first || !dialog.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !dialog.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  /* Delegated lazy binding (no observers): whenever focus moves or the user
     clicks (e.g. “Join LUCKY Rewards” opens the overlay), re-evaluate the
     trap so a late-mounted dialog still gets inert siblings + initial focus,
     and a dismissed dialog releases them. */
  document.addEventListener('focusin', function () {
    trap();
  }, true);
  document.addEventListener('click', function (event) {
    var t = event.target.closest && event.target.closest(
      '.klaviyo-close-form, [aria-label="Close"], [aria-label="Close dialog"], [aria-label="Reward"], #headlessui-portal-root, .lp99_modal, .klaviyo-form'
    );
    if (t || wasOpen) settle();
    else {
      setTimeout(trap, 150);
      setTimeout(trap, 600);
    }
  }, true);
  document.addEventListener('animationend', function (event) {
    if (event.target && event.target.closest && event.target.closest('[aria-label="Reward"], .klaviyo-form, #headlessui-portal-root')) {
      trap();
    }
  }, true);
  document.addEventListener('transitionend', function (event) {
    if (event.target && event.target.closest && event.target.closest('[aria-label="Reward"], .klaviyo-form, #headlessui-portal-root')) {
      trap();
    }
  }, true);

  window.lfA11y.once(trap, { priority: 'critical' });
  trap();
})();

/* Cookie consent overlay: focus the heading and trap until a choice is made */
(function () {
  var inerted = [];
  var lastDialog = null;

  function visible(el) {
    if (!(el instanceof Element)) return false;
    if (el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true') return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 2 && rect.height > 2;
  }

  /* Only the preferences overlay is modal. The corner consent banner must NOT
     inert the page or trap focus: QA sessions always start with it open, and a
     modal banner makes the whole storefront unreachable for keyboard/AT. */
  function cookieDialog() {
    var prefs = document.querySelector('#shopify-pc__prefs, [id^="shopify-pc__prefs"]:not(style)');
    if (prefs && visible(prefs)) return prefs;
    return null;
  }

  function cookieBanner() {
    var banner = document.querySelector('section#shopify-pc__banner, #shopify-pc__banner.shopify-pc__banner__dialog');
    if (banner && visible(banner)) return banner;
    return null;
  }

  function heading(dialog) {
    if (!dialog) return null;
    return document.getElementById('shopify-pc__banner__body-title') && dialog.contains(document.getElementById('shopify-pc__banner__body-title'))
      ? document.getElementById('shopify-pc__banner__body-title')
      : dialog.querySelector('h1, h2, h3, [id*="title"]');
  }

  function focusables(dialog) {
    return Array.prototype.filter.call(
      dialog.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) {
        if (el.disabled) return false;
        if (el.getAttribute('aria-hidden') === 'true') return false;
        var r = el.getBoundingClientRect();
        return r.width > 0 && r.height > 0;
      }
    );
  }

  function clearInert() {
    inerted.forEach(function (el) {
      el.inert = false;
      el.removeAttribute('aria-hidden');
    });
    inerted = [];
  }

  function applyInert(dialog) {
    clearInert();
    var node = dialog;
    while (node && node !== document.body) {
      var parent = node.parentElement;
      if (!parent) break;
      Array.prototype.forEach.call(parent.children, function (child) {
        if (child === node) return;
        if (child.id === 'shopify-pc__banner' || child.id === 'shopify-pc__prefs') return;
        if (child.id && String(child.id).indexOf('shopify-pc__') === 0) return;
        child.inert = true;
        child.removeAttribute('aria-hidden');
        inerted.push(child);
      });
      node = parent;
    }
  }

  function watchCookieNode(el) {
    if (!el || el.dataset.lfCookieWatch) return;
    el.dataset.lfCookieWatch = 'true';
    new MutationObserver(function () { sync(); }).observe(el, {
      attributes: true,
      attributeFilter: ['style', 'hidden', 'class', 'aria-hidden']
    });
  }

  function focusHeading(dialog) {
    var title = heading(dialog);
    if (!title) {
      if (dialog.tabIndex < 0) dialog.setAttribute('tabindex', '-1');
      dialog.focus();
      return;
    }
    if (title.tabIndex < 0) title.setAttribute('tabindex', '-1');
    title.focus();
  }

  function sync() {
    watchCookieNode(document.getElementById('shopify-pc__banner'));
    watchCookieNode(document.getElementById('shopify-pc__prefs'));
    var banner = cookieBanner();
    if (banner) {
      banner.removeAttribute('aria-modal');
      if (!banner.getAttribute('role') || banner.getAttribute('role') === 'alertdialog') {
        banner.setAttribute('role', 'region');
      }
      if (!banner.getAttribute('aria-label')) banner.setAttribute('aria-label', 'Cookie consent');
    }
    var dialog = cookieDialog();
    if (!dialog) {
      if (inerted.length) clearInert();
      lastDialog = null;
      return;
    }
    dialog.setAttribute('role', dialog.getAttribute('role') || 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    if (lastDialog !== dialog || !dialog.contains(document.activeElement)) {
      focusHeading(dialog);
    }
    applyInert(dialog);
    lastDialog = dialog;
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var dialog = cookieDialog();
    if (!dialog) return;
    var list = focusables(dialog);
    var title = heading(dialog);
    if (!list.length) {
      event.preventDefault();
      focusHeading(dialog);
      return;
    }
    var first = list[0];
    var last = list[list.length - 1];
    var active = document.activeElement;
    var outside = !dialog.contains(active);
    var onTitle = title && active === title;
    if (event.shiftKey && (outside || onTitle || active === first)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (outside || onTitle || active === last)) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  document.addEventListener('focusin', function (event) {
    var dialog = cookieDialog();
    if (!dialog) return;
    if (dialog.contains(event.target)) return;
    event.stopPropagation();
    focusHeading(dialog);
  }, true);

  document.addEventListener('click', function (event) {
    if (!(event.target.closest && event.target.closest('[id^="shopify-pc__"]'))) return;
    setTimeout(sync, 50);
    setTimeout(sync, 300);
    setTimeout(sync, 1000);
  }, true);

  ['visitorConsentCollected', 'trackingConsentAccepted'].forEach(function (name) {
    document.addEventListener(name, function () {
      setTimeout(sync, 0);
      setTimeout(sync, 300);
    });
  });

  window.lfA11y.once(sync, { priority: 'critical' });
})();

/* Focus is not trapped in the menu; it moves to background content (also Search overlay) */
(function () {
  var lastOpen = false;

  function menuOpen() {
    return document.body.classList.contains('reveal-mobile-nav');
  }

  function drawer() {
    return document.querySelector('.mobile-navigation-drawer');
  }

  function isVisibleBox(el) {
    if (!(el instanceof Element)) return false;
    if (el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true' || el.inert) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 2 && r.height > 2;
  }

  /* Cart / pickup / size-chart keep aria-modal="true" while closed. Only a
     visible, non-hidden dialog should disable the menu trap. */
  function otherModalOpen(root) {
    var modals = document.querySelectorAll('[role="dialog"][aria-modal="true"], [role="alertdialog"][aria-modal="true"]');
    for (var i = 0; i < modals.length; i++) {
      var el = modals[i];
      if (el === root || (root && root.contains(el))) continue;
      if (el.getAttribute('aria-hidden') === 'true' || el.hasAttribute('hidden') || el.inert) continue;
      if (el.classList.contains('invisible') || el.classList.contains('hidden')) continue;
      if (isVisibleBox(el)) return true;
    }
    return false;
  }

  function isTabbable(el, root) {
    if (!(el instanceof Element) || el === root) return false;
    if (el.hasAttribute('data-lf-focus-guard')) return false;
    if (el.disabled || el.tabIndex < 0) return false;
    if (el.hasAttribute('hidden')) return false;
    var node = el;
    while (node && node !== root) {
      if (node.inert || node.getAttribute('aria-hidden') === 'true' || node.hasAttribute('hidden')) return false;
      var cs = window.getComputedStyle(node);
      if (cs.display === 'none' || cs.visibility === 'hidden') return false;
      node = node.parentElement;
    }
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 2 && r.height > 2;
  }

  function focusableIn(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex^="-"])'),
      function (el) { return isTabbable(el, root); }
    );
  }

  function ensureGuards(root) {
    if (!root || root.querySelector('[data-lf-focus-guard="start"]')) return;
    var start = document.createElement('div');
    var end = document.createElement('div');
    start.setAttribute('data-lf-focus-guard', 'start');
    end.setAttribute('data-lf-focus-guard', 'end');
    start.tabIndex = 0;
    end.tabIndex = 0;
    start.className = 'visually-hidden';
    end.className = 'visually-hidden';
    root.insertBefore(start, root.firstChild);
    root.appendChild(end);
  }

  function focusFirst(root) {
    var list = focusableIn(root);
    var close = root.querySelector('button.mobile-nav-toggle');
    (close || list[0] || root).focus();
  }

  function focusLast(root) {
    var list = focusableIn(root);
    if (list.length) list[list.length - 1].focus();
    else focusFirst(root);
  }

  /* A closed drawer is aria-hidden, and a leftover scan then stamps
     tabindex="-1" on every link inside. Opening must undo that or Tab
     skips the items and leaves the dialog. */
  function restoreTabStops(root) {
    window.lfInert.restoreTabStops(root);
    root.querySelectorAll('a[href][tabindex="-1"], button[tabindex="-1"]').forEach(function (el) {
      if (el.hasAttribute('data-lf-focus-guard')) return;
      el.removeAttribute('tabindex');
      if (el.getAttribute('aria-hidden') === 'true') el.removeAttribute('aria-hidden');
    });
  }

  function markDialog(root, open) {
    if (!root) return;
    if (open) {
      ensureGuards(root);
      restoreTabStops(root);
      root.setAttribute('role', 'dialog');
      root.setAttribute('aria-modal', 'true');
      root.removeAttribute('aria-hidden');
      if (!root.getAttribute('aria-label') && !root.getAttribute('aria-labelledby')) {
        root.setAttribute('aria-label', 'Menu');
      }
    } else {
      root.setAttribute('aria-hidden', 'true');
      root.removeAttribute('aria-modal');
      root.removeAttribute('role');
    }
  }

  function apply() {
    var root = drawer();
    var open = menuOpen();
    if (!open && !document.body.classList.contains('show-search')) {
      window.lfInert.release();
    }
    markDialog(root, open);
    if (!open || !root) return;
    if (!document.body.classList.contains('show-search')) {
      window.lfInert.release();
    }
    window.lfInert.hideSiblings(root);
    window.lfInert.restoreTabStops(root);
  }

  function syncTrap(force) {
    var open = menuOpen();
    if (!force && open === lastOpen) return;
    lastOpen = open;
    apply();
    if (!open) return;
    var root = drawer();
    if (!root) return;
    if (!root.contains(document.activeElement)) focusFirst(root);
  }

  function returnFocus(root) {
    if (!root || root.contains(document.activeElement)) return;
    if (otherModalOpen(root)) return;
    focusFirst(root);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && menuOpen()) {
      var close = drawer() && drawer().querySelector('button.mobile-nav-toggle');
      if (close) close.click();
      return;
    }
    if (event.key !== 'Tab') return;
    syncTrap();
    if (!menuOpen()) return;
    var root = drawer();
    if (!root) return;
    var list = focusableIn(root);
    if (!list.length) {
      event.preventDefault();
      event.stopImmediatePropagation();
      root.focus();
      return;
    }
    var first = list[0];
    var last = list[list.length - 1];
    var active = document.activeElement;
    if (event.shiftKey && (active === first || !root.contains(active))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      last.focus();
    } else if (!event.shiftKey && (active === last || !root.contains(active))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      first.focus();
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { returnFocus(root); });
    });
  }, true);

  /* Screen reader browse/swipe can land outside a Tab-only trap. Pull focus
     back unless another visible modal (Reward, cart) has taken over. */
  document.addEventListener('focusin', function (event) {
    if (!menuOpen()) return;
    var root = drawer();
    if (!root) return;
    var target = event.target;
    if (target && target.getAttribute && target.getAttribute('data-lf-focus-guard')) {
      if (target.getAttribute('data-lf-focus-guard') === 'start') focusLast(root);
      else focusFirst(root);
      return;
    }
    if (root.contains(target)) return;
    returnFocus(root);
  }, true);

  if (document.body) {
    new MutationObserver(function () { syncTrap(); }).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
    new MutationObserver(function () {
      if (menuOpen()) apply();
    }).observe(document.body, { childList: true });
  }

  document.addEventListener('click', function (event) {
    if (!(event.target.closest && event.target.closest('button.mobile-nav-toggle, .mobile-nav-toggle'))) return;
    setTimeout(function () { syncTrap(); }, 0);
  }, true);

  window.lfA11y.once(function () {
    lastOpen = menuOpen();
    apply();
  }, { priority: 'critical' });
})();

/* Skip links stay visually hidden until focus. Do not set aria-hidden:
   they are focusable, and aria-hidden on a focusable control fails 4.1.2. */
(function () {
  function clear(el) {
    if (!(el instanceof Element)) return;
    if (el.getAttribute('aria-hidden') === 'true') el.removeAttribute('aria-hidden');
    if (el.hasAttribute('data-lf-skip-hidden')) el.removeAttribute('data-lf-skip-hidden');
  }

  function scan() {
    document.querySelectorAll('a.skip-link').forEach(function (el) {
      clear(el);
      if (el.dataset.lfSkipWatch) return;
      el.dataset.lfSkipWatch = 'true';
      new MutationObserver(function () { clear(el); }).observe(el, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'data-lf-skip-hidden']
      });
    });
    document.querySelectorAll('a.product-link[aria-hidden="true"]').forEach(function (el) {
      el.removeAttribute('aria-hidden');
    });
  }

  window.lfA11y.once(scan, { priority: 'critical' });
})();

/* After the “Brooks” link, focus moves to hidden elements */
(function () {
  function sync(bar) {
    if (!bar || !bar.querySelectorAll) return;
    bar.removeAttribute('tabindex');
    var wrap = bar.querySelector('.container');
    if (wrap) wrap.removeAttribute('tabindex');
    bar.querySelectorAll('.announcement').forEach(function (slide) {
      var hidden = slide.classList.contains('announcement--inactive');
      if (hidden) {
        slide.inert = true;
        slide.removeAttribute('aria-hidden');
        window.lfInert.hideTabStops(slide);
      } else {
        slide.inert = false;
        slide.removeAttribute('aria-hidden');
        window.lfInert.restoreTabStops(slide);
      }
    });
  }

  function scan() {
    document.querySelectorAll('announcement-bar').forEach(function (bar) {
      sync(bar);
      if (bar.dataset.lfAnnSync) return;
      bar.dataset.lfAnnSync = 'true';
      new MutationObserver(function () { sync(bar); }).observe(bar, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }

  function releaseHeaderWhenIdle() {
    if (document.body.classList.contains('show-search')) return;
    if (document.body.classList.contains('reveal-mobile-nav')) return;
    window.lfInert.releaseChrome();
  }

  window.lfA11y.once(function () {
    scan();
    releaseHeaderWhenIdle();
  }, { priority: 'critical' });
})();
